<div class="row center-xs">
  <div [class]="'col-xs-' + columnCount">
    <mat-accordion>
      <mat-expansion-panel #panel>
        <mat-expansion-panel-header>
          <mat-panel-title style="align-self: center">{{ 'CONTROLS.filters' | translate }}</mat-panel-title>
          <mat-panel-description>
            <mat-chip-listbox>
              @for (field of active; track field) {
                @if (field.visible !== false) {
                  <mat-chip-option (removed)="resetField(field.name)"
                    [removable]="true"
                    class="filter-chip">
                    <span>{{ field.translateLabel ? (field.label | translate) : field.label }}: {{ field.value.formatted }}</span>
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-option>
                }
              }
              @if (visibleFieldCount !== 0) {
                <mat-chip-option (removed)="reset()"
                  class="filter-chip"
                  color="primary">
                  <span>{{ 'CONTROLS.reset_filter' | translate }}</span>
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
              }
            </mat-chip-listbox>

            <ng-content select=".r-side"></ng-content>

          </mat-panel-description>
        </mat-expansion-panel-header>
        <form [formGroup]="form">
          <!--  FORM SLOT   -->
          <ng-content></ng-content>

          <div class="buttons">
            <div class="actions">
              <button (click)="reset(); panel.close()" color="warn" type="button" mat-stroked-button>
                <mat-icon style="margin-right: 5px;">close</mat-icon>
                <span>{{ 'CONTROLS.reset' | translate }}</span>
              </button>
              <button (click)="onFilterChanged($event.ctrlKey); panel.close()" color="primary" type="submit"
                mat-stroked-button>
                <mat-icon style="margin-right: 5px;">search</mat-icon>
                <span>{{ 'QUERY_BUILDER.apply' | translate }}</span>
              </button>
            </div>

            <div class="hint">
              {{ eagerModeHint }}
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
